import useStorages from "@/hooks/useStorages";
import { useEffect } from "react";
import PageTitle from "features/navigation/pageTitle";

const ForbiddenPage = () => {

    const {
        reloadStorages
    } = useStorages();

    useEffect(() => {
        // Reload storages when the component mounts
        reloadStorages();
    }, [reloadStorages]);

    return (
        <>
            <PageTitle title="401 - Forbidden" />
            <p>You do not have permission to access this page.</p>
        </>
    );
}

export default ForbiddenPage;

